import LinkAction from "./link-action/LinkAction";
import ModalAction from "./modal-action/ModalAction";
import {KmsTypeAction} from "@mediaspace/shared/types";
import { ActionProps } from "./../ActionsMenu";

export type ActionsItemProps = {
    itemProps: KmsTypeActionWithAutoFocus;
    populateModal: (data: ActionProps) => void;
}

export interface KmsTypeActionWithAutoFocus extends KmsTypeAction {
    autoFocus?: boolean;
}

/**
 * actions menu item
 */
const ActionsItem = (actionsIemProps: ActionsItemProps) => {

    const {itemProps, populateModal} = actionsIemProps;
    const {label, props} = itemProps;

    return itemProps.link ?
        <LinkAction
            {...itemProps}
        /> :
        <ModalAction
            populateModal={populateModal}
            label={label}
            props={props}
        />;
}

export default ActionsItem;
